var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"popup"},[_c('p',{staticClass:"popup__text",class:{ 'popup__text--green': _vm.good, 'popup__text--red': !_vm.good }},[_c('span',[_vm._t("default")],2),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }